import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

import { useAppNudgeStore } from "@faire/retailer/features/Nudges/useAppNudgeStore";
import { getSettingEnableKnownReferrerAdoption } from "@faire/retailer/settings/getSettingEnableKnownReferrerAdoption";
import { getSettingEnableReferralAdoption } from "@faire/retailer/settings/getSettingEnableReferralAdoption";
import {
  useMilestone,
  useIsMilestoneOverWeekOld,
} from "@faire/retailer/stores/domain/useMilestone";

export enum KnownReferrerNudges {
  NONE = "NONE",
  BRAND_SPECIFIC_1 = "BRAND_SPECIFIC_1",
  BRAND_SPECIFIC_2 = "BRAND_SPECIFIC_2",
  GENERIC = "GENERIC",
}

export const useKnownReferrerNudgeEligibility = () => {
  const [{ hasAcknowledgedKnownReferrerNudge }, setAppNudgeStore] =
    useAppNudgeStore(["hasAcknowledgedKnownReferrerNudge"]);

  const { hasOccurred: hasSeenBrandSpecificNudge1 } = useMilestone(
    "FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN"
  );
  const { hasOccurred: hasSeenBrandSpecificNudge2 } = useMilestone(
    "SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN"
  );
  const { hasOccurred: hasSeenGenericNudge } = useMilestone(
    "THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN"
  );

  const firstNudgeWeekStale = useIsMilestoneOverWeekOld(
    "FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN"
  );
  const secondNudgeWeekStale = useIsMilestoneOverWeekOld(
    "SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN"
  );

  const secondNudgeEligible = hasSeenBrandSpecificNudge1 && firstNudgeWeekStale;
  const thirdNudgeEligible =
    hasSeenBrandSpecificNudge1 &&
    hasSeenBrandSpecificNudge2 &&
    secondNudgeWeekStale;

  let nudgeToShow: KnownReferrerNudges = KnownReferrerNudges.NONE;
  if (hasSeenBrandSpecificNudge1 === false) {
    nudgeToShow = KnownReferrerNudges.BRAND_SPECIFIC_1;
  } else if (hasSeenBrandSpecificNudge2 === false && secondNudgeEligible) {
    nudgeToShow = KnownReferrerNudges.BRAND_SPECIFIC_2;
  } else if (hasSeenGenericNudge === false && thirdNudgeEligible) {
    nudgeToShow = KnownReferrerNudges.GENERIC;
  }

  const brandsToRefer = getGlobalProperty<Array<string>>(
    "knownReferrerAdoptionBrandNames"
  );

  const shouldShowKnownReferrerNudge =
    nudgeToShow !== KnownReferrerNudges.NONE &&
    hasAcknowledgedKnownReferrerNudge !== true &&
    brandsToRefer &&
    brandsToRefer?.length >= 1 &&
    getSettingEnableKnownReferrerAdoption() &&
    (!getSettingEnableReferralAdoption() || hasSeenBrandSpecificNudge1);

  return {
    shouldShowKnownReferrerNudge,
    nudgeToShow,
    hasAcknowledgedKnownReferrerNudge,
    setAppNudgeStore,
  };
};
